/**
 * The note worth showing beside a payout: why it failed, or why it was
 * rejected, each only on its own status. A payout recorded as paid after
 * Paystack confirmed a late transfer keeps the note it was closed with, and
 * that note is not the story of a completed payout.
 */
export function payoutNote(payout: {
  status: string
  failureReason?: string | null
  adminNote?: string | null
}): string | null {
  if (payout.status === 'FAILED') return payout.failureReason || null
  if (payout.status === 'REJECTED') return payout.adminNote || null
  return null
}
